import styled from "styled-components";

export const CustomCheckboxInput = styled.input`
	min-width: 18px;
	min-height: 18px;
`;
